import { render } from "./InfoTip.vue?vue&type=template&id=2cf61af5&scoped=true&ts=true"
import script from "./InfoTip.vue?vue&type=script&lang=ts"
export * from "./InfoTip.vue?vue&type=script&lang=ts"

import "./InfoTip.vue?vue&type=style&index=0&id=2cf61af5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf61af5"]])

export default __exports__